import { useContext } from "react";
import { EnrollmentActionContext } from "./EnrollmentActionContext";

function useInitialize() {
  const { setElement, setShowModal } = useContext(EnrollmentActionContext);
  return (formDefaultValues: any) => {
    setElement(formDefaultValues);
    setShowModal(true);
  };
}

export default useInitialize;
